"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantStatus = void 0;
var MerchantStatus;
(function (MerchantStatus) {
    MerchantStatus["ACTIVE"] = "ACTIVE";
    MerchantStatus["INACTIVE"] = "INACTIVE";
    MerchantStatus["PENDING"] = "PENDING";
})(MerchantStatus || (exports.MerchantStatus = MerchantStatus = {}));
//# sourceMappingURL=merchant.js.map